<template>
  <v-app-bar color="primary" dense dark>

    <template v-if="selected.length > 0">
      <v-btn small light >
        {{selected.length +' '+ $tc('selected',selected.length)}}
      </v-btn>

      <v-btn small color="secondary" dark v-if="selected.length == 1 && editPermission" class="ml-5" :title="$t('edit')" @click="sendAction('edit')">
        {{$t('edit')}} <v-icon right>mdi-file-edit</v-icon>
      </v-btn>

      <v-btn small color="secondary" dark class="ml-5" :title="$t('delete')" @click="sendAction('massiveDelete')" v-if="deletePermission">
        {{$t('delete')}} <v-icon right>mdi-delete</v-icon>
      </v-btn>

    </template>

    <v-spacer></v-spacer>
    <v-toolbar-title v-if="selected.length > 0">
      <v-menu transition="slide-y-transition" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small color="green" dark v-bind="attrs" v-on="on" @click="sendAction('export')">
            {{ $t('export') }}
            <v-icon right>mdi-download</v-icon>
          </v-btn>
        </template>
<!--        <v-list dense>-->
<!--          <v-list-item dense>-->
<!--            <v-list-item-title>Excel</v-list-item-title>-->
<!--          </v-list-item>-->
<!--        </v-list>-->
      </v-menu>
    </v-toolbar-title>

  </v-app-bar>
</template>

<script>
export default {
  name: "ItemActions",
  props: {
    selected:{
      type: Array,
      default: []
    },
    editPermission:{
      type: Boolean,
      default: true
    },
    deletePermission:{
      type: Boolean,
      default: true
    }
  },
  methods:{
    sendAction(mode){
      this.$emit('message',mode)
    }
  }
}
</script>

<style scoped>

</style>